<ng-template #template let-anchor>
    <span>{{ anchor.nativeElement.innerText }}</span>
</ng-template>
<div
    class="loader-wrapper"
    kendoTooltip
    showOn="none"
    filter=".k-grid"
    [tooltipTemplate]="template"
    (mouseover)="showTooltip($event)">
    <app-loader [isBusy]="isBusy">
        <ng-template>
            <kendo-grid
                [data]="attachments"
                [skip]="itemPage.skip"
                [pageSize]="itemPage.pageSize"
                [pageable]="pagingOptions"
                [sort]="sort"
                [sortable]="{ allowUnsort: allowUnsort, mode: multiple ? 'multiple' : 'single' }"
                [resizable]="true"
                (pageChange)="pageChange($event, attachments)"
                (sortChange)="sortChange($event, attachments)">
                @if (showAddButton()) {
                    <ng-template kendoGridToolbarTemplate>
                        <button
                            class="btn btn-sm btn-primary mr-2"
                            kendoTooltip
                            title="{{ 'Add Attachment' | translate }}"
                            [disabled]="isOnlyWatcher"
                            (click)="openNewAttachmentDialog()">
                            <fa-icon [icon]="['fas', 'plus']"></fa-icon>
                        </button>
                    </ng-template>
                }
                @if (hasPermission('PcsApprovals.PcsApprovals.Edit')) {
                    <kendo-grid-command-column title="" sortable="false" [width]="80">
                        <ng-template kendoGridCellTemplate let-row>
                            <button
                                class="btn btn-xs btn-danger"
                                kendoTooltip
                                title="{{ 'Remove' | translate }}"
                                [disabled]="
                                    currentDocumentStatus.id !== row.createdOnStatus.id ||
                                    !belongsToOrganization(row.organizationOfCreatedBy)
                                "
                                (click)="openRemoveAttachmentDialog(row.id)">
                                <fa-icon [icon]="['fas', 'trash']"></fa-icon>
                            </button>
                        </ng-template>
                    </kendo-grid-command-column>
                }
                <kendo-grid-column title="{{ 'Attachment Name' | translate }}" field="attachmentName" [width]="500">
                    <ng-template kendoGridCellTemplate let-row>
                        <a class="attachmentLink download-link" (click)="attachmentDownload(row.attachmentId)">
                            {{ row.attachmentName }}
                            <i class="fa fa-download" aria-hidden="true"></i>
                        </a>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column
                    title="{{ 'Description' | translate }}"
                    field="attachmentDescription"></kendo-grid-column>
                <kendo-grid-column title="{{ 'Created On Status' | translate }}">
                    <ng-template kendoGridCellTemplate let-row>
                        @if (row.createdOnStatus) {
                            <span>
                                {{ row.createdOnStatus.localizedCode + ' - ' + row.createdOnStatus.name }}
                            </span>
                        }
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="{{ 'Created By' | translate }}">
                    <ng-template kendoGridCellTemplate let-row>
                        @if (row.createdBy) {
                            <span>{{ row.createdBy.firstName + ' ' + row.createdBy.lastName }}</span>
                        }
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="{{ 'Created Date' | translate }}">
                    <ng-template kendoGridCellTemplate let-row>
                        @if (row.createdDate) {
                            <span>{{ row.createdDate | date: 'dd.MM.yyyy HH:mm' }}</span>
                        }
                    </ng-template>
                </kendo-grid-column>
                <ng-template kendoGridNoRecordsTemplate>
                    <p>{{ 'No records available' | translate }}.</p>
                </ng-template>
            </kendo-grid>
        </ng-template>
    </app-loader>
</div>
@if (newAttachmentDialog && !isOnlyWatcher) {
    <kendo-dialog title="{{ 'Add Attachment' | translate }}" [minWidth]="550" (close)="closeNewAttachmentDialog()">
        <div class="row">
            <span>{{ 'Attachment: ' | translate }}</span>
        </div>
        <div class="row">
            <kendo-fileselect
                [restrictions]="attachmentFileUploadRestrictions"
                [multiple]="false"
                (select)="fileSelected($event)"
                (remove)="fileRemoved($event)">
                <kendo-upload-messages
                    select="{{ 'Select File...' | translate }}"
                    dropFilesHere="{{ 'Drop file here to select' | translate }}"></kendo-upload-messages>
            </kendo-fileselect>
        </div>
        <div class="row">
            <span>{{ 'Description:' | translate }}</span>
        </div>
        <div class="row">
            <kendo-textarea #attachmentDescriptionTextArea resizable="none" [cols]="60" [rows]="3"></kendo-textarea>
        </div>
        <kendo-dialog-actions layout="end">
            <button
                class="btn btn-sm btn-primary mr-2"
                kendoButton
                [disabled]="fileToSend === null || currentlyUploading"
                (click)="submitNewAttachment()">
                <fa-icon [icon]="['fas', 'check']"></fa-icon>
                &nbsp;&nbsp;{{ 'Submit' | translate }}
            </button>
            <button
                class="btn btn-sm btn-secondary"
                kendoButton
                [disabled]="currentlyUploading"
                (click)="closeNewAttachmentDialog()">
                <fa-icon [icon]="['fas', 'times']"></fa-icon>
                &nbsp;&nbsp;{{ 'Cancel' | translate }}
            </button>
        </kendo-dialog-actions>
    </kendo-dialog>
}
@if (removeAttachmentDialog) {
    <kendo-dialog
        title="{{ 'Remove Attachment' | translate }}"
        [minWidth]="350"
        (close)="closeRemoveAttachmentDialog()">
        <div class="row">
            <span>{{ 'Are you sure you want to remove this attachment?' | translate }}</span>
        </div>
        <kendo-dialog-actions layout="end">
            <button class="btn btn-sm btn-danger mr-2" kendoButton (click)="submitRemoveAttachment()">
                <fa-icon [icon]="['fas', 'check']"></fa-icon>
                &nbsp;&nbsp;{{ 'Submit' | translate }}
            </button>
            <button class="btn btn-sm btn-secondary" kendoButton (click)="closeRemoveAttachmentDialog()">
                <fa-icon [icon]="['fas', 'times']"></fa-icon>
                &nbsp;&nbsp;{{ 'Cancel' | translate }}
            </button>
        </kendo-dialog-actions>
    </kendo-dialog>
}
